import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CameraStreamMonitorService {
  private cameraInactive$ = new BehaviorSubject<boolean>(false);
  private currentStream: MediaStream | null = null;
  private isMonitoring = false;

  get cameraInactive(): Observable<boolean> {
    return this.cameraInactive$.asObservable();
  }

  startMonitoring(mediaStream: MediaStream): void {
    if (this.isMonitoring) return;

    const videoTracks = mediaStream.getVideoTracks();
    if (videoTracks.length === 0) return;

    this.isMonitoring = true;
    this.currentStream = mediaStream;
    this.cameraInactive$.next(false);

    videoTracks.forEach(track => {
      track.onended = () => {
        if (this.isMonitoring) {
          this.cameraInactive$.next(true);
        }
      };
    });
  }

  stopMonitoring(): void {
    if (!this.isMonitoring) return;

    this.isMonitoring = false;

    if (this.currentStream) {
      this.currentStream.getVideoTracks().forEach(track => {
        track.onended = null;
      });
    }

    this.currentStream = null;
    this.cameraInactive$.next(false);
  }
}
